import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    padding-top: ${space.xl};
  }
`

export const LeftFeatured = styled.div`
  order: 2;
  width: 100%;

  @media (min-width: ${breakpoint.lg}) {
    order: 1;
    width: 47%;
    margin-right: 3%;
  }

  @media (min-width: ${breakpoint.lg}) {
    width: 52%;
  }
`

export const Product = styled.div`
  order: 1;
  position: relative;
  width: calc(100% + ${space.xl3});
  margin-left: -${space.lg};
  margin-bottom: ${space.lg};

  @media (min-width: ${breakpoint.lg}) {
    order: 2;
    width: 40%;
    background-color: transparent;
  }

  @media (min-width: ${breakpoint.xl}) {
    width: 35%;
  }
`

export const ProductImg = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;

  img {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    height: auto;

    @media (min-width: ${breakpoint.lg}) {
      border-radius: ${borders.radius.lg};
    }
  }
`

export const OutlinedSquare = styled.div`
  display: none;
  position: absolute;
  left: -8%;
  bottom: -${space.xl};
  width: 100%;
  height: 100%;
  border: ${borders.sizes.md} dashed ${color.grayscale.gray};
  border-radius: ${borders.radius.xl};

  @media (min-width: ${breakpoint.lg}) {
    display: block;
  }
`
